/**
 * SelectField Component
 * 
 * Reusable dropdown/select component with consistent styling
 * and support for dynamic options.
 */
import React from 'react';

const SelectField = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  placeholder = 'Select an option',
  className = ''
}) => {
  const id = `field-${name}`;
  
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      <select
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        required={required}
        className="w-full p-2 border border-gray-300 rounded-md"
      >
        <option value="">{placeholder}</option>
        {options.map((option, index) => (
          <option key={index} value={typeof option === 'object' ? option.value : option}>
            {typeof option === 'object' ? option.label : option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectField; 